import cancellationPortal from '@cancellation-portal/internationalization/localization-messages/CancellationPortal/nb-NO.json';
import cancellationPortalAgencyAgreement from '@cancellation-portal/internationalization/localization-messages/cancellations/cancellation-portal/cancellation-portal-agency-agreement/nb-NO.json';

export const nbNOTranslations = {
  CancellationPortal: cancellationPortal,
  'cancellations/cancellation-portal/cancellation-portal-agency-agreement': cancellationPortalAgencyAgreement,
};
